import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Package, ArrowLeftRight, PackagePlus, FileText, Monitor, Trash2, CheckSquare } from 'lucide-react';

export default function WarehouseLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const role = user?.role;

  const isAdmin = role === 'ADMIN' || role === 'DIRECTOR';
  const isRM = role === 'REGIONAL_MANAGER';

  const tabs = [
    {
      id: 'stocks',
      path: '/warehouse/stocks',
      label: 'Остатки',
      icon: <Package className="w-4 h-4 mr-2" />,
      show: true,
    },
    {
      id: 'purchases',
      path: '/warehouse/purchases',
      label: 'Приходы',
      icon: <PackagePlus className="w-4 h-4 mr-2" />,
      show: user?.can_view_purchase_prices === true || user?.can_view_branch_purchases === true,
    },
    {
      id: 'transfers',
      path: '/warehouse/transfers',
      label: 'Перемещения',
      icon: <ArrowLeftRight className="w-4 h-4 mr-2" />,
      show: true,
    },
    {
      id: 'returns',
      path: '/warehouse/returns',
      label: 'Возвраты',
      icon: <ArrowLeftRight className="w-4 h-4 mr-2 text-rose-500" />,
      show: true,
    },
    {
      id: 'write-offs',
      path: '/warehouse/write-offs',
      label: 'Списания',
      icon: <Trash2 className="w-4 h-4 mr-2 text-red-500" />,
      show: true,
    },
    {
      id: 'adjustments',
      path: '/warehouse/adjustments',
      label: 'Корректировки',
      icon: <CheckSquare className="w-4 h-4 mr-2 text-purple-500" />,
      show: true,
    },
    {
      id: 'equipment',
      path: '/warehouse/equipment',
      label: 'Оборудование',
      icon: <Monitor className="w-4 h-4 mr-2 text-violet-500" />,
      show: isAdmin || isRM,
    },
    {
      id: 'material',
      path: '/warehouse/material',
      label: 'Мат. отчет',
      icon: <FileText className="w-4 h-4 mr-2 text-teal-500" />,
      show: true,
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4">
        <div>
          <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Склад</h2>
          <p className="text-muted-foreground text-sm mt-1">Управление запасами и движением товаров</p>
        </div>

        <div className="w-full overflow-x-auto pb-1 scrollbar-none">
          <div className="inline-flex h-10 items-center justify-center rounded-sm bg-slate-100 p-1 text-slate-500 dark:bg-slate-800 dark:text-slate-400">
            {tabs
              .filter((t) => t.show)
              .map((tab) => {
                const isActive = location.pathname.startsWith(tab.path);
                return (
                  <button
                    key={tab.id}
                    onClick={() => navigate(tab.path)}
                    className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-800 ${
                      isActive
                        ? 'bg-white text-slate-950 shadow-xs dark:bg-slate-950 dark:text-slate-50'
                        : 'hover:bg-slate-200/50 hover:text-slate-900 dark:hover:bg-slate-700/50 dark:hover:text-slate-50'
                    }`}
                  >
                    {tab.icon}
                    {tab.label}
                  </button>
                );
              })}
          </div>
        </div>
      </div>

      <div className="mt-2">
        <Outlet />
      </div>
    </div>
  );
}
